import produce, { castDraft, } from 'immer';
import { HomesActionType, } from './actions';
const homesByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case HomesActionType.SET_USER_HOMES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                actualAction.homes.items.forEach((home) => {
                    draft[home.id] = home;
                });
            });
        case HomesActionType.SET_PROJECT_HOMES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                actualAction.homes.items.forEach((home) => {
                    draft[home.id] = home;
                });
            });
        case HomesActionType.SET_HOME:
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft[actualAction.home.id] = actualAction.home;
            });
        default:
            return currentState;
    }
};
const homeIdsByUserIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case HomesActionType.SET_USER_HOMES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.userId] || {};
                draft[actualAction.userId] = temp;
                temp[actualAction.searchParams] = {
                    range: actualAction.homes.range,
                    items: actualAction.homes.items.map((home) => {
                        return home.id;
                    }),
                };
            });
        case HomesActionType.CLEAR_USER_HOMES:
            return produce(currentState, (draft) => {
                const { userId } = action;
                delete draft[userId];
            });
        default:
            return currentState;
    }
};
const homeIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case HomesActionType.SET_PROJECT_HOMES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.projectId] || {};
                draft[actualAction.projectId] = temp;
                temp[actualAction.searchParams] = {
                    range: actualAction.homes.range,
                    items: actualAction.homes.items.map((home) => {
                        return home.id;
                    }),
                };
            });
        case HomesActionType.CLEAR_PROJECT_HOMES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
export const homesStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.homesById = homesByIdReducer(currentState.homesById, action);
        draft.homeIdsByUserId = castDraft(homeIdsByUserIdReducer(currentState.homeIdsByUserId, action));
        draft.homeIdsByProjectId = castDraft(homeIdsByProjectIdReducer(currentState.homeIdsByProjectId, action));
    });
};
